import { render } from "./HemerotecaEvents.vue?vue&type=template&id=50a0eac0&scoped=true&lang=html"
import script from "./HemerotecaEvents.vue?vue&type=script&lang=js"
export * from "./HemerotecaEvents.vue?vue&type=script&lang=js"

import "./HemerotecaEvents.vue?vue&type=style&index=0&id=50a0eac0&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a0eac0"]])

export default __exports__